import React, { Component } from 'react';
import { graphql } from '@apollo/client/react/hoc';
import {gql} from '@apollo/client';
import {
  CONTENTFUL_NEWS_PAGE_SIZE,
  fetchAllNewsItemsPages,
  shouldPaginateNewsItems,
} from '../../utils/contentfulNewsPagination';

export default function homeWithData(WrappedComponent, options = {}) {
	const QUERY = gql `query homePageQuery($newsSkip: Int, $newsLimit: Int) {
				newsItems(skip: $newsSkip, limit: $newsLimit) {
									visibilityValue
									videoLink
			            newsTitle
			            route
			            date
			            description
			            department{
										visibilityValue
			            	name
			            	route
			            }
			              image {
							    title
							    description
							    url
							}
					}
					_newsItemsMeta {
						count
					}
					galleryPages(q:"fields.route=video-series") {
					  backgroundHeader
					  backgroundDescription
					  route
					  galleryGroups{
					  	name
					  	description
					  	galleryItems{
								visibilityValue
					  		name
					  		description
					  		releaseDate
					  		snapshotTime
					  		showDetails
					  		file{
			                  title
			                  description
			                  url
			                }
			            }
					  }
				    backgroundImage {
				      title
				      description
				      url
				    }
					}
			   globalSites{
			   	defaultImage {
						   title
						   description
						   url
						 }
					homePage {
						featuredTweet {
					        tweet
					        route
					        twitterHandle
					      }
						 backgroundImage {
						   title
						   description
						   url
						 }
						 socialMediaHeader
						 newsHeader
						 valueHeader
						 quickLinks {
						   route
						   text
	   		       fileLink{
                 title
                 description
                 url
               }
						 }
						 externalLinks {
						   route
						   text
						   image{
							url
							title
						   }
						 }
						 socialMedia {
						   handle
						   handleType
						 }
						 valueSection {
						 	valueIcon {
                             title
                             description
                             url
                           }
						   valueHeader
						   valueTitle
						   valueDescription
						 }
						 missionComponent {
						 	backgroundImage {
                            title
                            description
                            url
                          }
                          missionLogo {
                            title
                            description
                            url
                          }
                          missionHeader
                          missionText
                          goalsHeader
                          goals
						 }
						 valuesImage{
						 	url
						 }
						
					}
					homePageSeasonal {
						featuredTweet {
					        tweet
					        route
					        twitterHandle
					      }
						 backgroundImage {
						   title
						   description
						   url
						 }
						 socialMediaHeader
						 newsHeader
						 valueHeader
						 quickLinks {
						   route
						   text
	   		       fileLink{
                 title
                 description
                 url
               }
						 }
						 externalLinks {
						   route
						   text
						   image{
							url
							title
						   }
						 }
						 socialMedia {
						   handle
						   handleType
						 }
						 valueSection {
						 	valueIcon {
                             title
                             description
                             url
                           }
						   valueHeader
						   valueTitle
						   valueDescription
						 }
						 missionComponent {
						 	backgroundImage {
                            title
                            description
                            url
                          }
                          missionLogo {
                            title
                            description
                            url
                          }
                          missionHeader
                          missionText
                          goalsHeader
                          goals
						 }
						 valuesImage{
						 	url
						 }
						
					}
					feedback {
						 feedbackHeader
						 feedbackDescription
						 feedbackCtAtext
					   feedbackImage {
						 title
						 description
						 url
						}
					}
				  mainNavigation {
						 footerHeader
						 footerBody
						 copyrightHolder
						 primaryNavigationLinks{
							 route
							 text
						 }
						seasonalPrimaryNavigationLinks{
						  route
						  text
						}
						 footerLinks{
						   route
						   text
						 }
					   seasonalFooterLinks{
					      route
					      text
					   }
						 secondaryFooterLinks {
						   route
						   text
						 }
						 footerLogo {
						   title
						   description
						   url
						 }
				   }
				    cubsLogo{
		              title
		              url
		            }
			  }
		  }
	  `;

	const HOC = class extends Component {
		componentDidMount() {
			this.loadRemainingNewsItems();
		}

		componentDidUpdate(prevProps) {
			if (prevProps.homePageQuery !== this.props.homePageQuery) {
				this.loadRemainingNewsItems();
			}
		}

		componentWillUnmount() {
			this.unmounted = true;
		}

		async loadRemainingNewsItems() {
			const { homePageQuery } = this.props;

			if (this.loadingRemainingNews || !shouldPaginateNewsItems(homePageQuery)) {
				return;
			}

			this.loadingRemainingNews = true;

			try {
				await fetchAllNewsItemsPages(homePageQuery);
			} catch (error) {
				if (!this.unmounted) {
					console.warn('Unable to fetch all Contentful news items for homePageQuery.', error);
				}
			} finally {
				this.loadingRemainingNews = false;
			}
		}

		render() {
			return <WrappedComponent {...this.props}/>;
		}
	};

	return graphql(QUERY, {
		name: 'homePageQuery',
		options: {
			variables: {
				newsSkip: 0,
				newsLimit: CONTENTFUL_NEWS_PAGE_SIZE,
			},
			notifyOnNetworkStatusChange: true,
		},
	})(HOC);
}
